import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';
import { broadcastResponseToMainFrame } from '@azure/msal-browser/redirect-bridge';

import { AppModule } from './app/app.module';
import { environment } from '@environments/environment';
import { ConfigSettings, APP_CONFIG } from '@shared/config';
import { getConfig } from '@shared/config/config';

/**
 * Whether this document is the hidden iframe MSAL uses for silent token
 * renewal. msal-browser v5 requires that frame to hand the auth response back
 * to the parent window (redirect bridge); otherwise the parent waits a 10s
 * timeout before failing.
 */
function isMsalAuthFrame(): boolean {
  const hash = window.location.hash;
  const hasAuthResponse =
    hash.includes('state=') &&
    (hash.includes('code=') || hash.includes('error='));

  return window.parent !== window && hasAuthResponse;
}

if (isMsalAuthFrame()) {
  broadcastResponseToMainFrame().catch(error =>
    console.error('Error broadcasting auth response to main frame', error)
  );
} else {
  fetch(environment.appConfigUrl)
    .then(config => config.json())
    .then((settings: ConfigSettings) => {
      if (environment.production) {
        enableProdMode();
      }

      platformBrowser([
        {
          provide: APP_CONFIG,
          useValue: getConfig(settings),
        },
      ])
        .bootstrapModule(AppModule, {
          applicationProviders: [provideZoneChangeDetection()],
        })
        .catch(err => console.error(err));
    });
}
